import React, { useState } from "react";
import Button from "../Buttons/Button";

const ProgressTabAdv = ({
  tabs,
  activeTab = 0,
  onTabClick = () => console.log("TabClicked"),
}) => {
  return (
    <div className="w-full max-w-7xl flex justify-between  m-auto overflow-auto">
      {tabs.map((tab, index) => (
        <React.Fragment key={index}>
          <div className="tab-item flex gap-2 items-center relative pb-5 select-none">
            <div
              className={`flex justify-center items-center rounded-full aspect-square !text-xs border-[2px] shadow-lg
                    ${tab.color ? `text-${tab.color}` : `text-gray-400`}`}
            >
              <Button
                type="icon"
                variant="text"
                size="lg"
                icon={tab.icon}
                color={tab.color || "gray"}
                onClick={() => onTabClick(tab)}
              />
            </div>
            <div className="flex flex-col justify-center text-xs">
              <div
                className={`text-sm font-medium whitespace-nowrap ${
                  activeTab <= index ? `text-gray-400` : `text-dark`
                }`}
              >
                {tab.title}
              </div>
              {tab.status && tab.status.length > 0 && (
                <span
                  className={`text-${
                    tab.color || `gray-300`
                  } whitespace-nowrap`}
                >
                  {tab.status}
                </span>
              )}
            </div>
          </div>
          {index !== tabs.length - 1 && (
            <div
              className={`h-0.5 w-full  self-center -mt-6 min-w-10  bg-gray-300 mx-5`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressTabAdv;
